<template>
    <div class="auditor-invite page-invite">
        <data-form title="Invite Auditor"
                   tag="auditor-invite"
                   save-button-label="Send"
                   :field-model="fieldModel"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   submit-success-message="Invite sent"
                   submit-error-message="Error inviting user"
                   :submit-success-route="'/'">
        </data-form>
    </div>
</template>

<script>

import {email as emailValidator, required} from "vuelidate/lib/validators";
import Validation from "@/providers/Validation";

export default {
    name: 'AuditorInvite',
    data () {
        return {
            fieldModel: {
                fields: {
                    email: {
                        label: 'Email',
                        type: 'text',
                        validations: {
                            required,
                            email: emailValidator,
                        },
                        getDescription(model) {
                           return 'You may invite an existing user. They will be upgraded to auditor and notified.'
                        }
                    },

                }
            },
            fieldGroups: [['email']],
        }
    },
    methods: {
        onSubmit (modelInstance) {
            return this.$api.inviteAuditor(this, modelInstance).catch((error) => {
                this.$toasted.error(error.body.message)
                return Promise.reject()
            })
        }
    }
}
</script>
